export default __webpack_public_path__ + "static/media/vippng.com-paint-splater-png-917496.6d46d0fb.png";